import { render } from "./ToDo.vue?vue&type=template&id=075f66ca&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"

import "./ToDo.vue?vue&type=style&index=0&id=075f66ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075f66ca"]])

export default __exports__